import axios from 'axios';
import { getApiBase } from '@/config';

const client = axios.create({
  baseURL: getApiBase(),
  withCredentials: true,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});

// Update axios baseURL when config is reloaded (e.g. after loadRuntimeConfig())
export function setClientBaseURL(base: string): void {
  client.defaults.baseURL = base;
}

export default client;
